import { without } from 'lodash';
import {
  labeled,
  guidRequired,
  arrayOptional,
  custom,
  enumRequired,
  numberRequired,
  boolean
} from '../../util/joi';
import { YesNoOption, yesNoOptions } from '../global/YesNoOption.enum';

export const schema = (Joi: any, label: string) => {
  const availableYesNoOptions = without(
    yesNoOptions,
    YesNoOption.none.name,
    YesNoOption.yes_discharged.name,
    YesNoOption.not_important.name,
    YesNoOption.unsure.name
  );

  return Joi.object()
    .keys({
      planChangesToTheirFinancialCircumstances: enumRequired(
        Joi,
        availableYesNoOptions,
        labeled(
          label,
          'Do the applicant(s) plan or anticipate changes to their future financial circumstances that could POSITIVELY Impact their ability to repay the loan?'
        )
      )
    })
    .when('.planChangesToTheirFinancialCircumstances.name', {
      is: YesNoOption.yes.name,
      then: Joi.object().keys({
        applicants: arrayOptional(
          Joi,
          Joi.object().keys({
            idContact: guidRequired(Joi),
            isChanged: boolean(Joi)
          })
        )
          .has(
            Joi.object().keys({
              idContact: guidRequired(Joi),
              isChanged: boolean(Joi).invalid(false)
            })
          )
          .required()
          .messages({
            'array.hasKnown': '{{#label}} At least one applicant must be selected.',
            'array.hasUnknown': '{{#label}} At least one applicant must be selected.',
            'array.required': '{{#label}} At least one applicant must be selected.'
          })
          .label(
            labeled(
              label,
              'Specify to which applicant(s) the changes apply and answer the remaining questions for all applicants together.'
            )
          )
      })
    })
    .when('.planChangesToTheirFinancialCircumstances.name', {
      is: YesNoOption.yes.name,
      then: custom(Joi)
        .object()
        .keys({
          natureOfPlannedChange: custom(Joi)
            .object()
            .keys({
              reducedDebtCommitments: Joi.boolean(),
              increasedIncome: Joi.boolean(),
              decreasingExpenses: Joi.boolean()
            })
            .orValue('reducedDebtCommitments', 'increasedIncome', 'decreasingExpenses')
            .label(labeled(label, 'What is the nature of the planned or anticipated change?'))
            .when('.reducedDebtCommitments', {
              is: true,
              then: Joi.object().keys({
                reducedDebtCommitmentsPeriodOfImpact: Joi.string()
                  .required()
                  .label(labeled(label, 'Period of impact')),
                reducedDebtCommitmentsFinancialImpact: numberRequired(Joi, 1).label(
                  labeled(label, 'Financial impact per month')
                )
              })
            })
            .when('.increasedIncome', {
              is: true,
              then: Joi.object().keys({
                increasedIncomePeriodOfImpact: Joi.string()
                  .required()
                  .label(labeled(label, 'Period of impact')),
                increasedIncomeFinancialImpact: numberRequired(Joi, 1).label(
                  labeled(label, 'Financial impact per month')
                )
              })
            })
            .when('.decreasingExpenses', {
              is: true,
              then: Joi.object().keys({
                decreasingExpensesPeriodOfImpact: Joi.string()
                  .required()
                  .label(labeled(label, 'Period of impact')),
                decreasingExpensesFinancialImpact: numberRequired(Joi, 1).label(
                  labeled(label, 'Financial impact per month')
                )
              })
            })
        })
    });
};

export default {
  schema
};
